import { useClientEnvironment } from '@hooks/clientEnvironment';
import { UK_COUNTRY } from '@lib/utils/constants';
import { formatNumberUk } from '@lib/utils/stringHelper';

type UseCastingContactProps = {
  projectLocationCountry: string | null | undefined;
  projectCastingContactEmail: string | null | undefined;
  projectCastingContactPhone: string | null | undefined;
  projectCompanyName: string | null | undefined;
};
export const useCastingContact = ({
  projectLocationCountry,
  projectCastingContactEmail,
  projectCastingContactPhone,
  projectCompanyName,
}: UseCastingContactProps) => {
  const isUkProject = projectLocationCountry === UK_COUNTRY;
  const { data: clientEnvironment } = useClientEnvironment();
  const { identifier, isEveryset, name: clientName } = clientEnvironment || {};
  const isSandbox = identifier === 'sandbox';

  const castingPhone = isUkProject
    ? formatNumberUk(projectCastingContactPhone)
    : projectCastingContactPhone;

  const castingContact = {
    castingContact: projectCompanyName,
    castingEmail: projectCastingContactEmail,
    castingPhone: castingPhone,
  };

  if (isSandbox) {
    castingContact.castingContact = '[Casting Company Name]';

    if (isUkProject) {
      castingContact.castingPhone = '55555 555555';
    } else {
      castingContact.castingPhone = '(555) 555-5555';
    }
  } else if (isEveryset) {
    if (isUkProject) {
      castingContact.castingContact = 'Everyset UK Casting';
    }
  } else {
    castingContact.castingContact = clientName;
  }

  return castingContact;
};
